import React, { memo, useEffect, useState } from "react";
import styles from "./PublicSideMenu.module.scss";
import { animated, config, useSpring } from "@react-spring/web";
import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";

type Props = {
	menuOpen: boolean;
	closeMenu: () => void;
};

const PublicSideMenu: React.FC<Props> = memo((props: Props) => {
	const { menuOpen, closeMenu } = props;

	const [initialLoad, setInitialLoad] = useState(true);

	const navigate = useNavigate();
	const location = useLocation();

	function navigateToRecommendation() {
		closeMenu();
		navigate(`/${ApplicationRoutes.RECOMMENDATION}`);
	}

	function navigateToSignup() {
		navigate(ApplicationRoutes.CUSTOMER_SIGNUP);
	}

	const navigateToLogin = () => {
		closeMenu();
		navigate(`/${ApplicationRoutes.LOGIN}`);
	};

	function navigateToFAQ() {
		closeMenu();
		navigate(ApplicationRoutes.FAQ);
	}

	function navigateToComingSoon() {
		closeMenu();
		navigate(`/${ApplicationRoutes.COMING_SOON}`);
	}

	function navigateToLandingPage() {
		closeMenu();
		navigate(ApplicationRoutes.LANDING_PAGE);
	}

	const menuStyles = useSpring({
		from: {
			transform: menuOpen ? "translateX(100%)" : "translateX(0%)",
		},
		to: {
			transform: menuOpen ? "translateX(0%)" : "translateX(100%)",
		},
		config: config.stiff,
		immediate: initialLoad,
	});

	useEffect(() => {
		setInitialLoad(false);
	}, []);

	return (
		<animated.div style={menuStyles} className={styles.container}>
			<div className={styles.headerContainer}>
				<img src="../../images/yansa-logo.svg" alt="Logo" />
				<button className={`standardButton ${styles.loginButton}`} onClick={navigateToFAQ}></button>
				{/* <button className={`standardButton ${styles.loginButton}`} onClick={navigateToLogin}>
					Log in
				</button> */}
				<button className={`standardButton ${styles.menuButton}`} onClick={closeMenu}>
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M17 17L1 1M17 1L1 17" stroke="white" strokeWidth="2" strokeLinecap="round" />
					</svg>
				</button>
			</div>
			<div className={styles.linksContainer}>
				{/* <div className={styles.clickable} onClick={navigateToSignup}>
					Sign up
				</div> */}
				<div className={styles.clickable} onClick={navigateToLandingPage}>
					Home
				</div>
				<div className={styles.clickable} onClick={navigateToComingSoon}>
					About
				</div>
				{/* <div className={styles.clickable} onClick={navigateToFAQ}>
					FAQ
				</div> */}
			</div>
			<div className={styles.buttonContainer}>
				<button className={`standardButton ${styles.getSolarPowerButton}`} onClick={navigateToComingSoon}>
				{/* navigateToRecommendation */}
					Get Solar Power{" "}
					<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12.9328 9H0.757812V7H12.9328L7.33281 1.4L8.75781 0L16.7578 8L8.75781 16L7.33281 14.6L12.9328 9Z" fill="black" />
					</svg>
				</button>
				<button className={`standardButton ${styles.learnMoreButton}`}>Learn More</button>
			</div>
		</animated.div>
	);
});

export default PublicSideMenu;
